import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

interface Options {
	enabled?: boolean;
}

const fetchUser = async (userId?: string | null, includeIds?: boolean) => {
	let url = userId
		? `/socialprofile/mini-profile/${userId}/`
		: "/socialprofile/mini-profile/";

	if (includeIds) {
		url += "?include_ids=true";
	}

	const response = await cmsClient.get<User>(url);
	return response.data;
};

const useUser = (
	userId?: string | null,
	includeIds?: boolean,
	options: Options = { enabled: true }
) => {
	const query = useQuery(
		["user-pdt", userId, includeIds],
		() => fetchUser(userId, includeIds),
		{
			enabled: options.enabled
		}
	);

	return query;
};

export default useUser;
